<div class="container" [uiClipType]="enClipType" >
  <div class="body">{{ score | number: '2.1-1' }}</div>
</div>

